import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.js";
import { __require as o } from "../node_modules/.pnpm/color-convert@2.0.1/node_modules/color-convert/index.js";
var e = o();
var i = r(e);
export { i as default };